/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ConsumptionCostChartFactType {
    COMBINED = 'COST_COMBINED',
    WATER = 'COST_WATER',
    ENERGY = 'COST_ENERGY'
}


export function ConsumptionCostChartFactTypeFromJSON(json: any): ConsumptionCostChartFactType {
    return ConsumptionCostChartFactTypeFromJSONTyped(json, false);
}

export function ConsumptionCostChartFactTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConsumptionCostChartFactType {
    return json as ConsumptionCostChartFactType;
}

export function ConsumptionCostChartFactTypeToJSON(value?: ConsumptionCostChartFactType | null): any {
    return value as any;
}

